(function homesSectionSorter(global) {
  'use strict';

  let cardType = 0;
  const numberOfCards = 9;
  let customSort = null;

  let homeTabsSection = document.querySelector('#nhs_DetailTabBar');
  const tabsElements = {
    allHomesTab: homeTabsSection.querySelector('[data-allHomes]'),
    modelHomeTab: homeTabsSection.querySelector('[data-allModelHomes]'),
    availableNowTab: homeTabsSection.querySelector('[data-availableNowHomes]'),
    nowBuildingTab: homeTabsSection.querySelector('[data-nowBuildingHomes]'),
    readyToBuildTab: homeTabsSection.querySelector('[data-readyToBuildHomes]'),
    luxuryHomeTab: homeTabsSection.querySelector('[data-luxuryHomes]'),
    matchingHomes: document.getElementById('matchingHomesTab')
  };
  const tabKeys = Object.keys(tabsElements);
  let homeList = document.querySelectorAll('[data-home-section-item]');
  const homesContainer = document.querySelector('[data-homes-container]');
  let currentCardsfiltered = homeList.length;
  const cardTypeConst = {
    allHomesTab: 0,
    modelHomeTab: 1,
    availableNowTab: 2,
    nowBuildingTab: 3,
    readyToBuildTab: 4,
    luxuryHomeTab: 5,
    matchingHomes: 6
  };

  /**
    * Hides all home cards
    */
  function hideAllHomeCards() {
    let cardsToDisable = document.querySelectorAll('[data-home-section-item]');
    cardsToDisable = Array.prototype.slice.call(cardsToDisable);
    cardsToDisable.forEach(function (ele) {
      const element = ele;
      element.setAttribute('hidden', '');
    });
  }

  function updateHomesAndPlansSection(orderListToMatch) {
    customSort.sort(true, orderListToMatch);
  }

  /**
     * Gets a list of the builder ids selected as filters.
     * If no filters was selected, returns all builder ids, since we want to display all results in that case.
     */
  function getSelectedBuilderFilterIds() {
    let selectedBuilderIds = [];
    const builderFilters = document.querySelectorAll('[data-builder-filter]');

    if (builderFilters) {
      const selectedBuilders = document.querySelectorAll('[data-builder-filter]:checked');
      let filterElements;

      if (selectedBuilders.length === 0) {
        filterElements = builderFilters;
      } else {
        filterElements = selectedBuilders;
      }

      for (let i = 0; i < filterElements.length; i += 1) {
        selectedBuilderIds.push(filterElements[i].getAttribute('data-builder-id'));
      }
    }

    return selectedBuilderIds;
  }

  /**
    * Checks if a home in the Homes & Plans section should be displayed,
    * according with the current builder and tab filters selected.
    * @param {HTMLElement} home The home card element to check.
    * @param {number} homeStatus The status code of the selected tab.
    * @returns True if should be displayed, false otherwise.
    */
  function isFilteredHome(homeElem, homeStatus) {
    const selectedBuilderFilterIds = getSelectedBuilderFilterIds();
    const status = +homeStatus;
    const matchesTab = status === 0 ||
        (+homeElem.dataset.status) === status ||
        (status === 5 && (+homeElem.dataset.luxury) === 1) ||
        (status === 6 && homeElem.dataset.isMatchingHome === 'true');

    // builder filters only exists in MPC pages, so have to we check is they exist
    const homeExistsInTabFilter = selectedBuilderFilterIds.length === 0 &&
        matchesTab;
    const homeExistsInBuilderFilter = selectedBuilderFilterIds.length > 0 &&
        selectedBuilderFilterIds.indexOf(homeElem.dataset.builderId) > -1 &&
        matchesTab;

    return homeExistsInTabFilter || homeExistsInBuilderFilter;
  }

  function hideElementsFromHomeList(listHome, homeStatus) {
    let displaySeeMore = false;
    let elementsVisible = 0;

    hideAllHomeCards();

    for (let i = 0; i < listHome.length; i += 1) {
      const currentHome = listHome[i];
      const displayHomeCard = isFilteredHome(currentHome, homeStatus);

      if (displayHomeCard) {
        if (elementsVisible === numberOfCards) {
          displaySeeMore = true;
          break;
        } else {
          elementsVisible += 1;
          currentHome.removeAttribute('hidden');
        }
      }
    }

    const seeMoreElement = document.getElementById('nhs_seeMore');

    if (seeMoreElement) {
      if (displaySeeMore) {
        seeMoreElement.removeAttribute('hidden');
      } else {
        seeMoreElement.setAttribute('hidden', '');
      }
    }
  }

  function getListFromTab(listHome, homeStatus) {
    let selectedBuilderFilterIds = getSelectedBuilderFilterIds();
    const list = listHome.filter(function (e) {
      if (selectedBuilderFilterIds) {
        return e.dataset.status === homeStatus.toString() &&
            selectedBuilderFilterIds.indexOf(e.dataset.builderId) > -1;
      }
      return e.dataset.status === homeStatus.toString();
    });
    return list;
  }

  function getMatchingList(listHome) {
    const list = listHome.filter(function (e) {
      return e.dataset.isMatchingHome === 'true';
    });
    return list;
  }

  function sortHomesAndPlans() {
    let len = document.querySelectorAll('#HomesAndPlans [data-home-section-item]').length;
    let size = numberOfCards;
    customSort = new global.Compare({
      totalItems: len,
      selector: 'div [data-home-section-item]:not([hidden])',
      attr: {
        Status: ['data-deal', 'data-status', 'data-price'],
        Price: ['data-price', 'data-name'],
        Name: ['data-name', 'data-price'],
        Size: ['data-bed', 'data-bath', 'data-garage', 'data-price']
      },
      attrOrd: {
        Status: ['desc', 'asc', 'desc'],
        Price: ['desc', 'asc'],
        Name: ['asc', 'desc'],
        Size: ['desc', 'desc', 'desc', 'desc']
      },
      attrSort: function () {
        return document.querySelector('[data-sort-options]').value;
      },
      trigger: ['[data-sort-options]'],
      caseSensitive: false,
      naturalSort: true,
      event: ['change'],
      page: 1,
      size: size
    });
  }

  function openHomeCard(event) {
    const target = event.target;
    const homeCard = target.closest('[data-home-section-item]');
    if (!homeCard) {
      return;
    }

    if (target.closest('[data-favorite-trigger]')) {
      return;
    }

    const link = homeCard.querySelector('[data-link]');
    window.location.href = link.href;
  }

  function setUp() {
    if (homeList) {
      homeList = Array.prototype.slice.call(homeList);
      hideElementsFromHomeList(homeList, cardTypeConst.allHomesTab);
    }

    if (!homeTabsSection) {
      return;
    }

    tabKeys.forEach(tab => {
      const element = tabsElements[tab];
      if (element) {
        element.addEventListener('click', function (event) {
          const currentActiveElement = homeTabsSection.querySelector('[data-active]');
          currentActiveElement.removeAttribute('data-active');
          currentActiveElement.classList.remove('nhs-c-button--tap-light-active');
          event.target.classList.add('nhs-c-button--tap-light-active');
          event.target.dataset.active = 'true';
          cardType = cardTypeConst[tab];
          hideElementsFromHomeList(homeList, cardTypeConst[tab]);
          let orderListToMatch = tab === 'matchingHomes' ? getMatchingList(homeList)
            : getListFromTab(homeList, cardTypeConst[tab]);
          updateHomesAndPlansSection(orderListToMatch);
          currentCardsfiltered = element.dataset.cards;
        });
      }
    });

    let seeMoreButton = document.getElementById('nhs_seeMore');
    if (seeMoreButton) {
      seeMoreButton.onclick = function () {
        let allHomes = document.querySelectorAll('[data-home-section-item]');
        let allHomesShown = [];
        let hiddenHomes = [];

        switch (cardType) {
          case 0: // All Homes Tab
            for (let i = 0; i < allHomes.length; i += 1) {
              if (allHomes[i].offsetParent === null &&
                      hiddenHomes.length < 9 &&
                      isFilteredHome(allHomes[i], cardType)) {
                hiddenHomes.push(allHomes[i]);
                allHomes[i].removeAttribute('hidden');
              }
              if (!allHomes[i].hidden) {
                allHomesShown.push(allHomes[i]);
              }
            }
            break;
          case 5: // Luxury Tab
          case 6: // Matching Homes Tab
          default: // Any other tab
            for (let i = 0; i < allHomes.length; i += 1) {
              if (allHomes[i].offsetParent === null &&
                        hiddenHomes.length < numberOfCards &&
                        isFilteredHome(allHomes[i], cardType)) {
                hiddenHomes.push(allHomes[i]);
                allHomes[i].removeAttribute('hidden');
              }
              if (!allHomes[i].hidden) {
                allHomesShown.push(allHomes[i]);
              }
            }
        }

        if (allHomesShown.length >= currentCardsfiltered) {
          const seeMoreButtonElement = document.getElementById('nhs_seeMore');

          if (seeMoreButtonElement) {
            seeMoreButtonElement.setAttribute('hidden', '');
          }
        }
        customSort.size += numberOfCards;
        let changeEvent = new Event("change");
        document.querySelector('[data-sort-options]').dispatchEvent(changeEvent);
      };
    }
    homesContainer.addEventListener('click', openHomeCard);
    sortHomesAndPlans();
  }

  setUp();
}(window));
